module.exports = __webpack_public_path__ + "static/media/19ESCAP32.60e145d1.jpg";